"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreMenu = void 0;
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const ExportFormat_1 = __importDefault(require("@opsbase/lib-general/ExportFormat"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useInterval_1 = __importDefault(require("@opsbase/react-hooks/useInterval"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useDataTreeActions_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTreeActions"));
const useNewDataActions_1 = __importDefault(require("@opsbase/web-ctrl-newdata/useNewDataActions"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const ChartsIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChartsIcon"));
const CollapseMoreIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CollapseMoreIcon"));
const ColumnIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ColumnIcon"));
const ExpandMoreIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ExpandMoreIcon"));
const ExportIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ExportIcon"));
const ImportIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ImportIcon"));
const OptionsIcon_1 = __importDefault(require("@opsbase/web-icons/icons/OptionsIcon"));
const PrintChartIcon_1 = __importDefault(require("@opsbase/web-icons/icons/PrintChartIcon"));
const RepeatRoundedIcon_1 = __importDefault(require("@opsbase/web-icons/icons/RepeatRoundedIcon"));
const SaveIcon_1 = __importDefault(require("@opsbase/web-icons/icons/SaveIcon"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const ActionButton_1 = __importDefault(require("@opsbase/web-ui/ActionButton/ActionButton"));
const ActionButtonContainer_1 = __importDefault(require("@opsbase/web-ui/ActionButtonContainer/ActionButtonContainer"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const PercentCircle_1 = __importDefault(require("@opsbase/web-ui/PercentCircle"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (showMoreMenu, showExportMenu) => {
    return {
        mainButton: {
            minHeight: 42,
            zIndex: 201,
        },
        mainMenu: {
            position: 'absolute',
            padding: 4,
            paddingRight: 12,
            backgroundColor: 'white',
            borderRadius: '4px 0 0 4px',
            border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
            borderLeft: `4px solid ${lib_palette_1.default.secondary.main}`,
            opacity: showMoreMenu ? 1 : 0,
            pointerEvents: showMoreMenu ? undefined : 'none',
            overflow: showMoreMenu ? 'initial' : 'hidden',
            top: 0,
            right: -8,
            maxWidth: showMoreMenu ? 500 : 0,
            zIndex: 200,
            transition: 'max-width 0.15s, opacity 0.15s',
        },
        exportMenu: {
            position: 'absolute',
            height: 'fit-content',
            width: 'fit-content',
            padding: 4,
            top: 36,
            left: -4,
            zIndex: 200,
            opacity: showExportMenu ? 1 : 0,
            pointerEvents: showExportMenu ? undefined : 'none',
            transition: 'opacity 0.15s',
            backgroundColor: 'white',
            borderRadius: '0 0 4px 4px',
            border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
            borderTop: 0,
            borderBottom: `4px solid ${lib_palette_1.default.secondary.main}`,
        },
    };
};
function MoreMenu(props) {
    const { disableFieldSelection = false, additionalMoreButtons = [], disableCharts = false, disableSaving = false, disableExpand = false, fieldSelector, } = props;
    const dt = (0, useDataTree_1.default)();
    const { isDirty, autoRefresh, groupBys, type, chartBox } = (0, useView_1.default)(dt.viewId);
    const { refresh, toggleChartBox } = (0, useViewActions_1.default)(dt.viewId);
    const { expandToDepth } = (0, useDataTreeActions_1.default)();
    const { goTo } = (0, useNav_1.default)();
    const [showMoreMenu, setShowMoreMenu] = (0, react_1.useState)(false);
    const [showExportMenu, setShowExportMenu] = (0, react_1.useState)(false);
    const [refreshTimer, setRefreshTimer] = (0, react_1.useState)(0);
    const timeoutMainRef = (0, react_1.useRef)();
    const timeoutExportRef = (0, react_1.useRef)();
    const metaModel = MetaModelRegistry_1.default[type];
    const myCss = (0, web_css_1.default)(makeMyClasses, [showMoreMenu, showExportMenu]);
    const isGrouping = !!groupBys.length;
    const showCharts = chartBox.visible;
    const hasCharts = !!chartBox.charts.length;
    const { clearItemsForType } = (0, useNewDataActions_1.default)();
    (0, useInterval_1.default)(() => {
        if (!dt.dataStatus.loading) {
            let t = refreshTimer + (1 / autoRefresh) * 100;
            if (t >= 100) {
                refresh();
                t = 0;
            }
            setRefreshTimer(t);
        }
    }, autoRefresh ? 1000 : 0);
    const handleMouseEnterMoreButton = (0, react_1.useCallback)(() => {
        if (timeoutMainRef.current)
            clearTimeout(timeoutMainRef.current);
        timeoutMainRef.current = undefined;
        setShowMoreMenu(true);
    }, []);
    const handleOpenExportMenu = (0, react_1.useCallback)(() => {
        if (timeoutExportRef.current)
            clearTimeout(timeoutExportRef.current);
        timeoutExportRef.current = undefined;
        setShowExportMenu(true);
    }, []);
    const handleCloseExportMenu = (0, react_1.useCallback)(() => {
        timeoutExportRef.current = setTimeout(() => {
            setShowExportMenu(false);
        }, 400);
    }, []);
    const handleClose = (0, react_1.useCallback)(() => {
        timeoutMainRef.current = setTimeout(() => {
            setShowMoreMenu(false);
            handleCloseExportMenu();
        }, 400);
    }, [handleCloseExportMenu]);
    const handleMouseEnter = (0, react_1.useCallback)(() => {
        if (timeoutMainRef.current)
            clearTimeout(timeoutMainRef.current);
        timeoutMainRef.current = undefined;
    }, []);
    const handleEnterExportMenu = (0, react_1.useCallback)(() => {
        if (timeoutExportRef.current)
            clearTimeout(timeoutExportRef.current);
        timeoutExportRef.current = undefined;
    }, []);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        handleClose();
    }, [handleClose]);
    const handleClickCreate = (0, react_1.useCallback)(() => {
        handleClose();
        goTo(lib_pages_1.default.REPORT_CREATE, { viewId: dt.viewId }, { fieldSelector });
    }, [dt.viewId, fieldSelector, goTo, handleClose]);
    const handleClickRefresh = (0, react_1.useCallback)(() => {
        setRefreshTimer(0);
        handleClose();
        clearItemsForType(dt.viewId);
        refresh();
    }, [clearItemsForType, dt.viewId, handleClose, refresh]);
    const handleCharts = (0, react_1.useCallback)(() => {
        toggleChartBox(!chartBox.visible);
    }, [toggleChartBox, chartBox]);
    const handleImport = (0, react_1.useCallback)(() => {
        handleClose();
        goTo(lib_pages_1.default.IMPORT_DATA, { type }, { fieldSelector });
    }, [fieldSelector, goTo, handleClose, type]);
    const handleColumns = (0, react_1.useCallback)(() => {
        handleClose();
        goTo(lib_pages_1.default.REPORT_COLUMNS, { viewId: dt.viewId }, { fieldSelector });
    }, [handleClose, goTo, dt.viewId, fieldSelector]);
    const handleExpand = (0, react_1.useCallback)(() => expandToDepth(1), [expandToDepth]);
    const handleCollapse = (0, react_1.useCallback)(() => expandToDepth(-1), [expandToDepth]);
    const handleExportGroupDetailPDF = (0, react_1.useCallback)(() => {
        goTo(lib_pages_1.default.REPORT_EXPORT, {
            viewId: dt.viewId,
            type: ExportFormat_1.default.GROUP_DETAIL_PDF,
        }, { fieldSelector });
        handleClose();
    }, [goTo, dt.viewId, fieldSelector, handleClose]);
    const handleExportPDF = (0, react_1.useCallback)(() => {
        goTo(lib_pages_1.default.REPORT_EXPORT, { viewId: dt.viewId, type: ExportFormat_1.default.PDF }, { fieldSelector });
        handleClose();
    }, [goTo, dt.viewId, fieldSelector, handleClose]);
    const handleExportJSON = (0, react_1.useCallback)(() => {
        goTo(lib_pages_1.default.REPORT_EXPORT, { viewId: dt.viewId, type: ExportFormat_1.default.JSON }, { fieldSelector });
        handleClose();
    }, [goTo, dt.viewId, fieldSelector, handleClose]);
    const handleExportXML = (0, react_1.useCallback)(() => {
        goTo(lib_pages_1.default.REPORT_EXPORT, { viewId: dt.viewId, type: ExportFormat_1.default.XML }, { fieldSelector });
        handleClose();
    }, [goTo, dt.viewId, fieldSelector, handleClose]);
    const handleExportCSV = (0, react_1.useCallback)(() => {
        goTo(lib_pages_1.default.REPORT_EXPORT, { viewId: dt.viewId, type: ExportFormat_1.default.CSV }, { fieldSelector });
        handleClose();
    }, [goTo, dt.viewId, fieldSelector, handleClose]);
    const [moreButtons, alwaysButtons] = (0, react_1.useMemo)(() => {
        const _moreButtons = [];
        const _alwaysButtons = [];
        // COLLAPSE
        if (!!isGrouping && !disableExpand) {
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "collapse", Icon: CollapseMoreIcon_1.default, onClick: handleCollapse, tooltip: lib_i18n_1.default.t('collapse-desc'), label: lib_i18n_1.default.t('collapse') }));
        }
        // EXPAND
        if (!!isGrouping && !disableExpand) {
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "expand", Icon: ExpandMoreIcon_1.default, onClick: handleExpand, tooltip: lib_i18n_1.default.t('expand-desc'), label: lib_i18n_1.default.t('expand') }));
        }
        if (!!isGrouping && metaModel.canExportPDF) {
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "exportgrouppdf", Icon: PrintChartIcon_1.default, label: lib_i18n_1.default.t('print'), onClick: handleExportGroupDetailPDF }));
        }
        // CHARTS TOGGLE BUTTON
        if (!disableCharts && !!hasCharts)
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "charts", Icon: ChartsIcon_1.default, highlight: showCharts, onClick: handleCharts, tooltip: showCharts ? lib_i18n_1.default.t('hide-charts') : lib_i18n_1.default.t('show-charts'), label: lib_i18n_1.default.t('charts') }));
        // SAVE
        if (!disableSaving && metaModel.canSaveReports)
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "save", Icon: SaveIcon_1.default, highlight: isDirty, onClick: handleClickCreate, tooltip: lib_i18n_1.default.t('save-desc'), label: lib_i18n_1.default.t('save') }));
        // IMPORT
        if (metaModel.canImportData)
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "import", Icon: ImportIcon_1.default, tooltip: lib_i18n_1.default.t('import-desc'), label: lib_i18n_1.default.t('import'), onClick: handleImport }));
        // EXPORT
        if (metaModel.canExportPDF && !metaModel.canExportData)
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "export", Icon: ExportIcon_1.default, onClick: handleExportPDF, tooltip: lib_i18n_1.default.t('pdf-desc'), label: lib_i18n_1.default.t('pdf') }));
        if (metaModel.canExportData)
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "export", Icon: ExportIcon_1.default, label: lib_i18n_1.default.t('export'), onMouseEnter: handleOpenExportMenu, onMouseLeave: handleCloseExportMenu },
                react_1.default.createElement(Vertical_1.default, { classes: { root: myCss.exportMenu }, onMouseEnter: handleEnterExportMenu, gutter: true },
                    metaModel.canExportPDF && (react_1.default.createElement(ActionButton_1.default, { key: "exportpdf", onClick: handleExportPDF, tooltip: lib_i18n_1.default.t('pdf-desc'), label: lib_i18n_1.default.t('pdf') })),
                    metaModel.canExportData && (react_1.default.createElement(ActionButton_1.default, { key: "exportcsv", onClick: handleExportCSV, tooltip: lib_i18n_1.default.t('csv-desc'), label: lib_i18n_1.default.t('csv') })),
                    metaModel.canExportData && (react_1.default.createElement(ActionButton_1.default, { key: "exportjson", onClick: handleExportJSON, tooltip: lib_i18n_1.default.t('json-desc'), label: lib_i18n_1.default.t('json') })),
                    metaModel.canExportData && (react_1.default.createElement(ActionButton_1.default, { key: "exportxml", onClick: handleExportXML, tooltip: lib_i18n_1.default.t('xml-desc'), label: lib_i18n_1.default.t('xml') })))));
        // COLUMNS
        if (!disableFieldSelection)
            _moreButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "columns", Icon: ColumnIcon_1.default, onClick: handleColumns, tooltip: lib_i18n_1.default.t('columns-desc'), label: lib_i18n_1.default.t('columns') }));
        // ADDITIONAL BUTTONS
        additionalMoreButtons.forEach(b => _alwaysButtons.push(b));
        // RELOAD - WITHOUT AUTO REFRESH
        if (!autoRefresh) {
            _alwaysButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "refresh", Icon: RepeatRoundedIcon_1.default, onClick: handleClickRefresh, tooltip: lib_i18n_1.default.t('reload-desc'), label: lib_i18n_1.default.t('reload') }));
        }
        // RELOAD - WITH AUTO REFRESH
        else {
            _alwaysButtons.push(react_1.default.createElement(ActionButton_1.default, { key: "refresh", children: react_1.default.createElement(PercentCircle_1.default, { strokeWidth: 4, percent: refreshTimer, size: 32, color: lib_palette_1.default.BlackCoral },
                    react_1.default.createElement(RepeatRoundedIcon_1.default, { size: 18, style: { marginTop: -10 } })), onClick: handleClickRefresh, tooltip: lib_i18n_1.default.t('reload-desc-auto', { mins: Math.floor(autoRefresh / 60) }), label: lib_i18n_1.default.t('reload') }));
        }
        return [_moreButtons, _alwaysButtons];
    }, [
        isGrouping,
        disableExpand,
        metaModel,
        disableCharts,
        hasCharts,
        showCharts,
        handleCharts,
        disableSaving,
        isDirty,
        handleClickCreate,
        handleImport,
        handleExportPDF,
        handleOpenExportMenu,
        handleCloseExportMenu,
        myCss,
        handleEnterExportMenu,
        handleExportCSV,
        handleExportJSON,
        handleExportXML,
        disableFieldSelection,
        handleColumns,
        additionalMoreButtons,
        autoRefresh,
        handleCollapse,
        handleExpand,
        handleExportGroupDetailPDF,
        handleClickRefresh,
        refreshTimer,
    ]);
    return (0, react_1.useMemo)(() => {
        if (moreButtons.length < 4) {
            return (react_1.default.createElement(ActionButtonContainer_1.default, null, [...moreButtons, ...alwaysButtons]));
        }
        return (react_1.default.createElement(ActionButtonContainer_1.default, { onMouseLeave: handleMouseLeave },
            react_1.default.createElement("div", { style: { position: 'relative' } },
                react_1.default.createElement(ActionButtonContainer_1.default, { height: 32, onMouseEnter: handleMouseEnter, classes: { root: myCss.mainMenu } }, moreButtons)),
            react_1.default.createElement(ActionButtonContainer_1.default, null,
                react_1.default.createElement(Button_1.default, { classes: { root: myCss.mainButton }, icon: react_1.default.createElement(OptionsIcon_1.default, null), color: showMoreMenu ? lib_palette_1.default.secondary : lib_palette_1.default.BlackCoral, small: true, background: !showMoreMenu, tooltip: lib_i18n_1.default.t('more-options'), onMouseEnter: handleMouseEnterMoreButton }),
                alwaysButtons)));
    }, [
        moreButtons,
        handleMouseLeave,
        handleMouseEnter,
        myCss,
        showMoreMenu,
        handleMouseEnterMoreButton,
        alwaysButtons,
    ]);
}
exports.MoreMenu = MoreMenu;
exports.default = MoreMenu;
